// extracted by mini-css-extract-plugin
export var active = "_gr-7";
export var blink = "_gr-8";
export var dropDownSelector = "_gr-4";
export var dropDownWrapper = "_gr-3";
export var fakeCursor = "_gr-6";
export var fontSizeButton = "_gr-9";
export var formQuillEditor = "_gr-0";
export var pressed = "_gr-a";
export var qlBlank = "_gr-1";
export var textFormattingToolbar = "_gr-2";
export var textToolbarOption = "_gr-5";